import { range } from 'lodash-es'
import { type CSSProperties, type ReactNode } from 'react'

/**
 * Renders a list of skeletons with fading opacity
 */
export default function LoadingSkeletons(props: {
  /**
   * Number of skeletons to render
   *
   * @default 3
   */
  amount?: number
  /**
   * `className` for every skeleton
   */
  className?: string
  /**
   * `style` for every skeleton
   */
  style?: CSSProperties
  children: ReactNode | ((index: number) => ReactNode)
}) {
  const { amount = 3 } = props

  return (
    <>
      {range(amount).map(idx => (
        <div
          key={idx}
          data-skeleton=""
          data-skeleton-index={idx}
          data-skeleton-first={idx === 0 ? '' : null}
          data-skeleton-last={idx === amount - 1 ? '' : null}
          className={props.className}
          style={{ opacity: 0.5 - (0.5 / amount) * idx, ...props.style }}
        >
          {typeof props.children === 'function'
            ? props.children(idx)
            : props.children}
        </div>
      ))}
    </>
  )
}
